import Link from "next/link";

export type PrimaryButtonProps = {
  text: string;
  navigateTo?: string;
  variant?: "primary" | "black";
  target?: string;
  className?: string;
  onClick?: () => void;
};

export const PrimaryButton = ({
  text,
  navigateTo,
  variant = "primary",
  target = "_self",
  className = "",
  onClick,
}: PrimaryButtonProps) => {
  const buttonClasses = `${
    variant === "primary"
      ? "inline-flex w-fit items-center justify-center rounded-full border border-red-500 px-4 py-1.5 text-sm text-red-500 transition-all hover:translate-y-[-2px] hover:bg-red-500 hover:text-white hover:shadow-lg active:translate-y-[0px] active:shadow-md md:px-6 md:py-2 md:text-base"
      : "inline-flex w-fit items-center justify-center rounded-full border border-black px-4 py-1.5 text-sm text-black transition-all hover:translate-y-[-2px] hover:bg-black hover:text-white hover:shadow-lg active:translate-y-[0px] active:shadow-md md:px-6 md:py-2 md:text-base"
  } ${className}`.trim();

  return navigateTo ? (
    <Link
      href={navigateTo}
      className={buttonClasses}
      target={target}
      rel="noopener noreferrer"
      onClick={onClick}
    >
      {text}
    </Link>
  ) : (
    <button className={buttonClasses} onClick={onClick}>
      {text}
    </button>
  );
};
